import { AppBar, IconButton, Menu, MenuItem, Toolbar } from "@mui/material";
import MoreIcon from "@mui/icons-material/MoreVert";
import React, { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { useNavigate, useLocation } from "react-router-dom";
import { Image } from "mui-image";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import SettingsIcon from "@mui/icons-material/Settings";
import ListItemIcon from "@mui/material/ListItemIcon";
import Avatar from "@mui/material/Avatar";
import { useAuth } from "../../context-providers/auth-provider";
import ROUTES from "../../routes/routes";
import cookdImg from "../../resources/images/cookd.svg";
import logo from "../../resources/images/logo_simple.svg";
import { useSettings } from "../../context-providers/settings-provider";

const useStyles = makeStyles()((theme) => ({
  mainBar: {
    background: theme.palette.primary.dark,
    maxHeight: "64px",
    transition: "max-height .3s",
  },

  appName: {
    pointerEvents: "none",
    width: "130px",
    margin: "auto",
    transition: "opacity .3s",
  },

  appLogo: {
    maxWidth: "40px",
    pointerEvents: "none",
    transition: "opacity .3s",
  },

  avatar: {
    background: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
  },

  collapsed: {
    maxHeight: "0px",
  },

  hidden: {
    opacity: 0,
  },

  hoverAvatar: {
    pointerEvent: "all",
    position: "fixed",
    right: "10px",
    top: "2px",
    padding: 0,
  },

  toolbar: {
    pointerEvents: "none",
  },
}));

export default function TopBar() {
  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const { classes, cx } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { logOut } = useAuth();
  const { publicSettings } = useSettings();

  const showAction =
    !location.pathname.startsWith(ROUTES.LOGIN) &&
    !location.pathname.startsWith(ROUTES.SIGNUP);

  const barVisible =
    location.pathname.startsWith(ROUTES.SIGNUP) ||
    location.pathname.startsWith(ROUTES.LOGIN) ||
    location.pathname.startsWith(ROUTES.SETTINGS) ||
    location.pathname.startsWith(ROUTES.SETUP) ||
    location.pathname.startsWith(ROUTES.HOME);

  useEffect(() => {}, [publicSettings]);

  function doLogOut() {
    setOptionsAnchorEl(null);
    logOut().then(() => {
      navigate(ROUTES.LOGIN);
    });
  }

  function openSettings() {
    navigate(ROUTES.SETTINGS);
    setOptionsAnchorEl(null);
  }

  function renderOptionsButton() {
    if (publicSettings && publicSettings.username) {
      return (
        <Avatar
          alt={publicSettings.username.toLocaleUpperCase()}
          src={publicSettings.img || "#"}
          className={classes.avatar}
        />
      );
    }

    return <MoreIcon fontSize="large" />;
  }

  function renderMenu() {
    return (
      <Menu
        anchorEl={optionsAnchorEl}
        open={Boolean(optionsAnchorEl)}
        onClose={() => setOptionsAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {publicSettings && publicSettings.username && (
          <MenuItem onClick={openSettings}>
            <ListItemIcon>
              <SettingsIcon fontSize="medium" />
            </ListItemIcon>
            Settings
          </MenuItem>
        )}
        <MenuItem onClick={doLogOut}>
          <ListItemIcon>
            <ExitToAppIcon fontSize="medium" />
          </ListItemIcon>
          Log Out
        </MenuItem>
      </Menu>
    );
  }

  return (
    <>
      <AppBar
        position="sticky"
        className={cx(classes.mainBar, { [classes.collapsed]: !barVisible })}
      >
        <Toolbar
          classes={{
            root: barVisible
              ? "MuiToolbar-root"
              : `.MuiToolbar-root ${classes.toolbar}`,
          }}
        >
          <Image
            className={cx(classes.appLogo, { [classes.hidden]: !barVisible })}
            src={logo}
            width="40px"
            style={{
              opacity: barVisible ? 1 : 0,
              pointerEvents: "none",
              background: "none",
              width: "45px",
              height: "45px",
              padding: 0,
            }}
            duration={0}
            showLoading={false}
          />
          <img
            className={cx(classes.appName, { [classes.hidden]: !barVisible })}
            src={cookdImg}
            alt="Cook'd"
          />
          {showAction && (
            <div>
              <IconButton
                edge="start"
                style={{ pointerEvents: "all", padding: 0 }}
                color="inherit"
                aria-label="more"
                onClick={(event: any) =>
                  setOptionsAnchorEl(event.currentTarget)
                }
              >
                {renderOptionsButton()}
              </IconButton>
              {renderMenu()}
            </div>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
}
